<template>
  <div class="flex flex-row items-center">
    <div
      class="rounded-sm mr-12 flex h-36 w-36 shrink-0 items-center justify-center"
      :class="{ 'bg-static-info-mid': hasBackground }"
    >
      <slot name="icon" />
    </div>
    <slot name="content" />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    hasBackground?: boolean
  }>(),
  { hasBackground: true },
)
</script>
